import EnumSignSource from "./gen/qsign/types/EnumSignSource";
const labels = {
  [EnumSignSource.MC]: "Marbes",
  [EnumSignSource.REMSIG]: "Remsig",
};
export function getCaption(source: EnumSource) {
  const caption = labels[source];
  return caption ? caption : "[" + source + "]";
}
